import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const clientError = ({
  status,
  code,
  message,
  retryable = false,
}) => ({ status, code, message, retryable });

const structuredHttpError = (status, data) => clientError({
  status,
  code: typeof data?.errorCode === "string"
    ? data.errorCode
    : typeof data?.code === "string"
      ? data.code
      : "request_failed",
  message: typeof data?.message === "string"
    ? data.message
    : "Não foi possível concluir a operação.",
  retryable: data?.retryable === true,
});

const configuredUrl = (path) => {
  if (!BASE) {
    throw clientError({
      status: 0,
      code: "configuration_error",
      message: "Backoffice não configurado.",
    });
  }

  let baseUrl;
  try {
    baseUrl = new URL(BASE);
  } catch {
    throw clientError({
      status: 0,
      code: "configuration_error",
      message: "Backoffice não configurado.",
    });
  }
  const basePath = baseUrl.pathname.replace(/\/+$/, "");
  const url = new URL(`${basePath}/${path}`, `${baseUrl.origin}/`);
  if (url.origin !== baseUrl.origin) {
    throw clientError({
      status: 0,
      code: "configuration_error",
      message: "Backoffice não configurado.",
    });
  }
  return url;
};

const productAccessFetch = async (path, { method = "GET", body } = {}) => {
  const url = configuredUrl(path);
  const { token } = cookies.get("userId") || {};
  let response;
  try {
    response = await fetch(url.toString(), {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw clientError({
      status: 0,
      code: "network_error",
      message: "Não foi possível comunicar com o servidor.",
      retryable: true,
    });
  }

  const data = await response.json().catch(() => null);
  if (!response.ok) throw structuredHttpError(response.status, data);
  return data;
};

const segment = (value) => encodeURIComponent(String(value));

export const fetchProductAccessCompanies = () => (
  productAccessFetch("product-access/companies")
);

export const fetchProductAccessCompany = (companyId) => (
  productAccessFetch(`product-access/companies/${segment(companyId)}`)
);

export const fetchProductAccessUsers = (companyId) => (
  productAccessFetch(`product-access/companies/${segment(companyId)}/users`)
);

export const updateCompanyEntitlement = (companyId, mutation) => (
  productAccessFetch(`product-access/companies/${segment(companyId)}`, {
    method: "PATCH",
    body: {
      product: mutation.product,
      state: mutation.state,
      ...(mutation.product === "director" ? { projectIds: mutation.projectIds } : {}),
      validFrom: mutation.validFrom,
      validUntil: mutation.validUntil,
      reason: mutation.reason,
      expectedVersion: mutation.expectedVersion,
    },
  })
);

export const updateUserProductProfile = (userId, companyId, mutation) => (
  productAccessFetch(
    `product-access/users/${segment(userId)}/companies/${segment(companyId)}`,
    {
      method: "PATCH",
      body: {
        profile: mutation.profile,
        state: mutation.state,
        validUntil: mutation.validUntil,
        reason: mutation.reason,
        expectedVersion: mutation.expectedVersion,
      },
    },
  )
);

export const fetchProductAccessAudit = (
  companyId,
  { page = 1, pageSize = 20 } = {},
) => {
  const query = new URLSearchParams({
    company_id: String(companyId),
    page: String(page),
    pageSize: String(pageSize),
  });
  return productAccessFetch(`product-access/audit?${query.toString()}`);
};
